import {useState, useEffect} from 'react';
import {useMediaQuery} from 'react-responsive';
import {generateMedia} from 'styled-media-query';

export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export function useBreakpoint() {
  const [isClient, setIsClient] = useState(false);

  const isMobile = useMediaQuery({
    maxWidth: breakpoints.sm - 1,
  });

  const isTablet = useMediaQuery({
    minWidth: breakpoints.sm,
    maxWidth: breakpoints.lg - 1,
  });

  const isDesktop = useMediaQuery({
    minWidth: breakpoints.lg,
  });

  useEffect(() => {
    if (typeof window !== 'undefined') setIsClient(true);
  }, []);

  return {
    isDesktop: isClient ? isDesktop : true,
    isTablet: isClient ? isTablet : false,
    isMobile: isClient ? isMobile : false,
  };
}

const media = generateMedia({
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
});

export const mq = {
  ltsm: media.lessThan('sm'),
  ltlg: media.lessThan('lg'),
  gtsm: media.greaterThan('sm'),
  gtmd: media.greaterThan('md'),
  gtlg: media.greaterThan('lg'),
  gtxl: media.greaterThan('xl'),
  gt2xl: media.greaterThan('2xl'),
};
